import { string } from "prop-types";

import styled from "styled-components";

import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";
import { motion } from "framer-motion";

import { ButtonWrapper } from "../shared";

const OpenNav = ({ color }) => (
  <Wrapper initial={{ scale: 0.5 }} animate={{ scale: 1 }}>
    <Circle />
    <Circle />
    <Circle />
    <Circle />
  </Wrapper>
);

OpenNav.propTypes = { color: string };

const CloseNav = ({ color }) => (
  <CloseButton2 $color={color} initial={{ scale: 0.5 }} animate={{ scale: 1 }}>
    <span className="fa-chevron-down fas" />
  </CloseButton2>
);

CloseNav.propTypes = { color: string };

const ButtonDisplay = () => {
  const { activeContentKey, setActiveContentKey } = useMemberToolbarStore();

  const handleClick = () => {
    if (activeContentKey === contentKeys.memberPortalNav) {
      setActiveContentKey(contentKeys.nothing);
    } else {
      setActiveContentKey(contentKeys.memberPortalNav);
    }
  };

  return (
    <SButtonWrapper
      onClick={handleClick}
      data-cy="MemberToolbar_HomeButton"
      DisplayComponent={
        activeContentKey === contentKeys.memberPortalNav ? CloseNav : OpenNav
      }
    />
  );
};

const SButtonWrapper = styled(ButtonWrapper)`
  display: flex;
  width: 40px;
  justify-content: center;
  align-items: center;
`;

const CloseButton2 = styled(motion.div)`
  background-color: white;
  color: #2867ac;
  border-radius: 100%;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;

  span {
    transform: translateY(2px);
  }
`;

const Wrapper = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 3px;
  align-items: center;
  justify-items: center;
`;

const Circle = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 100%;
  background-color: white;
`;

export default ButtonDisplay;
